<template>
  <default-layout>
    <vue-headful
      v-if="project && project.name"
      :title="`${project.name} | ${galleryTitle}`"
    />
    <v-alert v-model="alert" dismissible type="success">{{ scrollAlert }}</v-alert>
    <div class="masonry_container">
      <div v-masonry gutter="10" item-selector=".item" transition-duration="0">
        <div
          v-for="(item, index) in sortedMedia"
          :key="index"
          v-masonry-tile
          class="item"
          @click.stop="openCarouselOnIdx(index)"
        >
          <div v-if="item.image">
            <img :src="getCdn(`${item.image}?width=640`)"/>
            <div v-if="captionsVisible && item.caption" class="image-caption">
              {{ limitCaption(item.caption) }}
            </div>
          </div>
          <div v-if="item.thumbnail" class="thumbnail">
            <v-icon color="rgba(255,255,255,0.8)" size="70">play_circle_outline</v-icon>
            <img :src="getCdn(`${item.thumbnail}`)"/>
          </div>
        </div>
      </div>
    </div>
    <CarouselModal ref="carouselModal" :gallery="sortedMedia" v-on:video-scroll="showAllert"/>
  </default-layout>
</template>

<script>
/* ============
 * Images Gallery Page
 * ============
 *
 * Page where the user can view the account information.
 */

import DefaultLayout from '@/layouts/Default.vue';
import CarouselModal from '@/components/CarouselModal.vue';
import { mapGetters } from 'vuex';
import { cdnUrl } from '@/utils/urls';
import VueHeadful from 'vue-headful';

const MAX_CAPTION_LENGTH = 40;

export default {
  /**
   * The name of the page.
   */
  name: 'OrderProjectGallery',

  /**
   * The components that the page can use.
   */
  components: {
    DefaultLayout,
    CarouselModal,
    VueHeadful,
  },
  data() {
    return {
      dialogOpened: false,
      currentMedia: null,
      alert: false,
      scrollAlert: 0,
    };
  },
  computed: {
    ...mapGetters('project', ['project', 'pages']),
    galleryTitle() {
      const pages = this.pages || [];
      const page = pages.find(p => p && p.route === 'gallery');
      if (page && page.label) {
        return this.$t ? this.$t(page.label) : page.label;
      }
      return this.$t ? this.$t('Gallery') : 'Gallery';
    },
    captionsVisible() {
      return !this.project.gallery_captions_hidden;
    },
    sortedMedia() {
      let result;

      if (this.project && this.project.gallery.length > 0) {
        result = Array.from(this.project.gallery)
          .sort((a, b) => a.position - b.position);
      } else {
        // there is no gallery or gallery isn't an array -> return empty arr
        result = [];
      }

      return result;
    },
  },
  methods: {
    openCarouselOnIdx(index) {
      this.$refs.carouselModal.openOnIdx(index);
    },
    showAllert(action) {
      this.alert = true;
      this.scrollAlert += action;
    },
    getCdn(source) {
      return cdnUrl(source);
    },
    limitCaption(text) {
      const ellipsis = text.length > MAX_CAPTION_LENGTH;

      return text.slice(0, MAX_CAPTION_LENGTH) + (ellipsis ? '...' : '');
    },
  },
};
</script>

<style lang="scss">
.masonry_container {
  overflow: hidden;
  padding-left: 20px;
  padding-right: 10px;
  @supports (padding-left: env(safe-area-inset-left)) {
    padding-left: calc(env(safe-area-inset-left) + 20px);
    padding-right: calc(env(safe-area-inset-right) + 10px);
  }

  .item {
    width: calc(33.3333333% - 10px);
    margin-bottom: 10px;
    cursor: pointer;

    img {
      width: 100%;
      display: block;
    }

    .image-caption {
      position: absolute;
      right: 0;
      bottom: 0;
      margin: 7px;
      color: white;
      background: rgba(0, 0, 0, 0.7);
      padding: 5px;
      line-height: 1rem;
      border-radius: 5px;
      font-size: 0.875em;
      font-weight: 500;
    }

    .thumbnail {
      position: relative;

      i {
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -35px;
        margin-top: -35px;
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .masonry_container {
    .item {
      width: calc(50% - 10px);
    }
  }
}

@media screen and (max-width: 600px) {
  .masonry_container {
    padding-left: 10px;

    .item {
      width: 100%;
    }
  }
}

</style>
